import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import PasswordModal from "./passwordModal";
import {
  getVendorById,
  updatePortalUserThunk,
} from "../../../store/thunks/myProfileThunk";
import { useDispatch, useSelector } from "react-redux";
import { ContentInputField } from "../../../components/atoms/formFields/inputField/contentInputField";
import BottomRightButton from "../../../components/atoms/formFields/buttons/bottomRightButton";
import Select from "react-select";
import { getLanguagesThunk } from "../../../store/thunks/getLanguagesThunk";
import { resetUpdateVendor } from "../../../store/slices/myProfileSlice";
const PersonalInfo = ({ user, profilePic, id }) => {
  const { data: allLanguages } = useSelector(
    (state) => state?.getLanguages || {}
  );
  const { data: success } = useSelector(
    (state) => state?.updatePortalUser || {}
  );

  const dispatch = useDispatch();

  const [formState, setFormState] = useState({
    userId: "",
    userName: "",
    userEmail: "",
    userAddress: "",
    userType: "ADMIN",
    phoneNumber: { countryCode: "+91", dialNumber: "" },
    profilePicture: "",
    languagesKnow: [],
  });

  const userKnowsLangs = [];
  const defUserLangs = [];

  useEffect(() => {
    user?.userKnowsLanguages.forEach((lang) => {
      userKnowsLangs.push(lang?.id);
      defUserLangs.push({ label: lang?.name, value: lang?.id });
    });
  }, [user]);

  useEffect(() => {
    if (user) {
      const ids = user?.userKnowsLanguages?.map((lang) => lang?.id) || [];
      const objs =
        user?.userKnowsLanguages?.map((lang) => ({
          label: lang?.name,
          value: lang?.id,
        })) || [];

      setFormState({
        userId: user.id || "",
        userName: user.name?.en || user.userName || "",
        userEmail: user.email || "",
        userAddress: user.address || "",
        userType: user.userType || "ADMIN",
        phoneNumber: {
          countryCode: user.phone?.countryCode || "+91",
          dialNumber: user.phone?.dialNumber || "",
        },
        languagesKnow: ids,
        langsDefault: objs,
      });
    }
  }, [user, profilePic]);

  console.log("formState", formState);
  const [errors, setErrors] = useState();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      formState?.userName &&
      formState?.userEmail &&
      formState?.phoneNumber?.dialNumber &&
      formState?.languagesKnow?.length > 0
    ) {
      setErrors({});
      const payload = {
        id: formState?.userId,
        name: formState?.userName,
        email: formState?.userEmail,
        phoneNumber: formState.phoneNumber,
        userType: formState?.userType,
        languagesKnow: formState?.languagesKnow,
      };

      console.log("formState?.languagesKnow", formState?.languagesKnow);

      dispatch(
        updatePortalUserThunk({
          payload,
          profilePicture: profilePic || formState?.profilePicture,
        })
      );
    } else {
      setErrors({
        name: formState?.userName ? "" : "Name is Mandatory",
        email: formState?.userEmail ? "" : "Email is Mandatory",
        phone: formState?.phoneNumber?.dialNumber
          ? ""
          : "Phone Number is Mandatory",
        language:
          formState?.languagesKnow?.length > 0 ? "" : "Language is Mandatory",
      });
    }
  };

  useEffect(() => {
    dispatch(
      getLanguagesThunk({
        filterInput: {
          status: "ACTIVE",
        },
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(getVendorById({ id }));
      dispatch(resetUpdateVendor());
    }
  }, [success, id, dispatch]);

  return (
    <>
      <div className="add_customer_form border border-1 p-5" id="ant_inputs">
        <div className="login-warp m-auto">
          <Row gutter={[12, 12]}>
            <h5 className="d-block font-size-lg font-weight-bolder h5 p-0 pl-lg-2 w-100">
              Personal Info
            </h5>
            <Col className="gutter-row" xs={24} lg={8}>
              <div className="user_inputs">
                <ContentInputField
                  name="Full Name"
                  errors={errors?.name}
                  value={formState?.userName}
                  required={true}
                  onChange={(e) => {
                    setFormState({
                      ...formState,
                      userName: e.target.value,
                    });
                    setErrors({
                      ...errors,
                      name: e.target.value ? "" : "Name is Mandatory",
                    });
                  }}
                />
              </div>
            </Col>
            <Col className="gutter-row" xs={24} lg={8}>
              <div className="user_inputs">
                <ContentInputField
                  name="Phone Number"
                  disabled={true}
                  errors={errors?.phone ? " invalid" : ""}
                  className="font-size-h1"
                  value={formState.phoneNumber.dialNumber}
                  onChange={(e) => {
                    setFormState({
                      ...formState,
                      userPhone: e.target.value,
                    });
                    setErrors({
                      ...errors,
                      phone: e.target.value ? "" : "Phone Number is Mandatory",
                    });
                  }}
                />
              </div>
            </Col>
            <Col className="gutter-row" xs={24} lg={8}>
              <div className="user_inputs">
                <ContentInputField
                  errors={errors?.email}
                  required={true}
                  value={formState?.userEmail}
                  onChange={(e) => {
                    setFormState({
                      ...formState,
                      userEmail: e.target.value,
                    });
                    setErrors({
                      ...errors,
                      email: e.target.value ? "" : "Email is Mandatory",
                    });
                  }}
                  name="Email Address"
                />
              </div>
            </Col>

            <Col className="gutter-row" xs={24} lg={8}>
              <label className="font-weight-bolder font-size-sm">
                Languages Known <span style={{ color: "red" }}>*</span>
              </label>

              <Select
                options={allLanguages?.map((language) => ({
                  label: language?.langName,
                  value: language?.id,
                }))}
                className={errors?.language ? "invalid" : ""}
                placeholder="Languages Known"
                isMulti
                value={formState?.langsDefault}
                onChange={(val) => {
                  const langIds = val?.map((item) => item?.value) || [];
                  setFormState({
                    ...formState,
                    languagesKnow: langIds,
                    langsDefault: val,
                  });
                  setErrors({
                    ...errors,
                    language: langIds.length > 0 ? "" : "Language is Mandatory",
                  });
                }}
              />

              {errors?.language && (
                <small className="text-danger text-capitalize">
                  {errors.language}
                </small>
              )}
            </Col>
            <Col className="gutter-row" xs={24}>
              <div className="user_inputs">
                <span
                  className="cursor-pointer font-size-lg font-weight-bolder text-info"
                  data-toggle="modal"
                  data-target={`#updatePasswordModal_${id}`}
                >
                  Change password
                </span>
              </div>
            </Col>
          </Row>

          <div className="mt-10 text-center">
            <BottomRightButton
              name="Save Changes"
              onClick={(e) => {
                handleSubmit(e);
              }}
            />
          </div>
        </div>

        <PasswordModal data-toggle="modal" data-target="#updatePasswordModal" id={id} />
      </div>
    </>
  );
};

export default PersonalInfo;
